import { render, staticRenderFns } from "./ClienteListAddNew.vue?vue&type=template&id=55069f6a&"
import script from "./ClienteListAddNew.vue?vue&type=script&lang=js&"
export * from "./ClienteListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ClienteListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports